import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import BookPage from "@/pages/BookPage";
import ReviewsPage from "@/pages/ReviewsPage";
import MeetGreetPage from "@/pages/MeetGreetPage";
import OwnerPage from "@/pages/OwnerPage";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Navbar />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/meet-greet" element={<MeetGreetPage />} />
            <Route path="/owner" element={<OwnerPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              background: "#FFFBF0",
              color: "#2A1C3A",
              border: "2px solid rgba(63, 42, 86, 0.2)",
              fontFamily: "Nunito, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
